import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import InvoiceTableRow from '@aytm/lib/rfd-ui/components/payment/invoice-table/row'
import TextField from '@aytm/lib/rfd-ui/components/basic/text-field'

export default class InvoiceTableDiscountRow extends InvoiceTableRow {
  static propTypes = {
    row: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.number,
    valuesWidth: PropTypes.number,
    onChange: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.switchToEdit = this.switchToEdit.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
    this.codeChanged = this.codeChanged.bind(this)
    this.unsetCode = this.unsetCode.bind(this)
    this.state = {
      edit: false,
      checking: false,
      message: null,
      error: false
    }
  }

  UNSAFE_componentWillReceiveProps() {
    super.UNSAFE_componentWillReceiveProps()
    this.setState({
      checking: false,
      edit: false,
      message: null,
      error: false
    })
  }

  switchToEdit() {
    this.setState({ edit: true })
  }

  cancelEdit() {
    this.setState({
      edit: false,
      message: null,
      error: false
    })
  }

  codeChanged(code) {
    const { row, onChange } = this.props
    const url = row.get('checkDiscountURL')

    if (url) {
      this.setState({ checking: true })

      const checkData = row.get('checkDiscountData') || Map()

      railsPostFetch(url, {
        body: JSON.stringify(checkData.set('discount_code', code).toJS())
      })
        .then(response => response.json())
        .then(data => {
          if (!this.mounted) return
          if (data && 'string' == typeof data.status && 'OK' == data.status.toUpperCase()) {
            this.setState({
              checking: true,
              message: data && data.message,
              error: false
            })
            const id = row.get('id')
            if ('function' == typeof onChange) {
              onChange(
                Map({
                  [id]: Map({
                    type: 'discount',
                    value: code
                  })
                }),
                id,
                false !== row.get('update')
              )
            }
          } else {
            this.setState({
              checking: false,
              message: (data && data.message) || 'Your promotion code is not valid or already used.',
              error: true
            })
          }
        })
        .catch(_error => {
          if (this.mounted) this.setState({ checking: false })
        })
    }
  }

  unsetCode() {
    const { row, onChange } = this.props
    const url = row.get('unsetDiscountURL')

    if (url) {
      this.setState({ checking: true })

      const unsetData = row.get('unsetDiscountData') || Map()

      railsPostFetch(url, {
        body: JSON.stringify(unsetData.toJS())
      })
        .then(response => response.json())
        .then(data => {
          if (!this.mounted) return
          if (data && 'OK' == data.status) {
            this.setState({
              checking: true,
              message: null,
              error: false
            })
            const id = row.get('id')
            if ('function' == typeof onChange) {
              onChange(
                Map({
                  [id]: Map({
                    type: 'discount',
                    value: null
                  })
                }),
                id,
                false !== row.get('update')
              )
            }
          } else {
            this.setState({
              checking: false,
              message: this.preprocessText((data && data.message) || ''),
              error: false
            })
          }
        })
        .catch(_error => {
          if (this.mounted) this.setState({ checking: false })
        })
    } else {
      const id = row.get('id')
      if ('function' == typeof onChange) {
        onChange(
          Map({
            [id]: Map({
              type: 'discount',
              value: null
            })
          }),
          id,
          false !== row.get('update')
        )
      }
    }
  }

  renderEmptyState() {
    const { row, width, valuesWidth } = this.props
    const emptyText = row.get('emptyText') || 'Discounts:'
    const emptyPrompt = row.get('emptyPrompt') || 'Have a promocode?'

    return [
      <div className="rfd-ui-invoice-table-row-label" key="label" style={{ width: width }}>
        <div className="rfd-ui-invoice-table-text">
          <div className="rfd-ui-invoice-table-dotted">
            <div className="rfd-ui-invoice-table-dotted-text">
              {this.renderLeveledText(emptyText, row.get('level'), 'rfd-ui-invoice-table-row-label-text')}
            </div>
          </div>
        </div>
      </div>,
      <div className="rfd-ui-invoice-table-row-value" key="value" style={{ width: valuesWidth }}>
        <div
          className="rfd-ui-invoice-table-attach-discount rfd-ui-invoice-table-row-value-text"
          dangerouslySetInnerHTML={{ __html: this.preprocessText(emptyPrompt) }}
          onClick={this.switchToEdit}
        />
      </div>
    ]
  }

  renderFilledState() {
    const { row, width, valuesWidth } = this.props
    const { checking } = this.state
    const setText = row.get('setText') || 'Discounts:'
    const value = this.preprocessText(row.get('value'))

    return [
      <div
        className="rfd-ui-invoice-table-row-label rfd-ui-invoice-table-row-label-green"
        key="label"
        style={{ width: width }}
      >
        <div className="rfd-ui-invoice-table-text">
          <div className="rfd-ui-invoice-table-dotted">
            <div className="rfd-ui-invoice-table-dotted-text">
              {this.renderLeveledText(setText, row.get('level'), 'rfd-ui-invoice-table-row-label-text')}
            </div>
          </div>
        </div>
      </div>,
      <div className="rfd-ui-invoice-table-row-value" key="value" style={{ width: valuesWidth }}>
        <div className="rfd-ui-invoice-table-row-value-text" dangerouslySetInnerHTML={{ __html: value }} />
        <i
          className={`rfd-ui-invoice-table-discount-unset ${
            checking ? 'icon-aytmfd-spin afd-spin' : 'icon-aytmfd-delete'
          }`}
          onClick={this.unsetCode}
        />
      </div>
    ]
  }

  renderEditState() {
    const { row, width, valuesWidth } = this.props
    const { checking, error } = this.state
    const editText = row.get('editText') || 'Promocode:'

    return [
      <div
        className={`rfd-ui-invoice-table-row-label${error ? ' rfd-ui-invoice-table-row-label-error' : ''}`}
        key="label"
        style={{ width: width }}
      >
        <div className="rfd-ui-invoice-table-text">
          <div className="rfd-ui-invoice-table-dotted">
            <div className="rfd-ui-invoice-table-dotted-text">
              {this.renderLeveledText(editText, row.get('level'), 'rfd-ui-invoice-table-row-label-text')}
            </div>
          </div>
        </div>
      </div>,
      <div
        className="rfd-ui-invoice-table-row-value rfd-ui-invoice-table-edit-discount"
        key="value"
        style={{ width: valuesWidth }}
      >
        <TextField
          width={valuesWidth ? valuesWidth - 12 : 160}
          ref={this.saveRef('EditCode')}
          onChange={this.codeChanged}
          icon={checking ? 'icon-aytmfd-spin afd-spin' : 'icon-aytmfd-x'}
          iconColor="#999999"
          debounce={350}
          error={error}
          onIconClick={this.cancelEdit}
        />
      </div>
    ]
  }

  render() {
    const { row, width } = this.props
    const { edit } = this.state
    const message = row.get('message') || this.state.message
    const error = row.get('error') || this.state.error

    return (
      <div className="rfd-ui-invoice-table-row-bordered-container">
        {edit && this.renderEditState()}
        {!edit && !row.has('value') && this.renderEmptyState()}
        {!edit && row.has('value') && this.renderFilledState()}
        {message && (
          <div className="rfd-ui-invoice-table-row-label" key="label" style={{ width: width }}>
            <div className="rfd-ui-invoice-table-text">
              {this.renderLeveledText(
                message,
                row.get('level'),
                `rfd-ui-invoice-table-discount-message${error ? ' rfd-ui-invoice-table-discount-error' : ''}`
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}
